import React from "react";
import {
  formatIncomeAmount,
  formatReportingPeriod,
  IncomeStatusBadge,
} from "./IncomeListHelpers";
import IncomeRowActions from "./IncomeRowActions";

const YoutubePeriodBreakdown = ({
  data: group,
  onEdit,
  onDelete,
  onGenerateInvoice,
  onCsvAction,
  onRetry,
  onViewReport,
  isIncomeProcessing,
  isIncomeDeleting,
  isRetryPending,
  isInvoicePending,
}) => {
  const rows = Array.isArray(group?.rows) ? group.rows : [];

  return (
    <div className="inc-period-breakdown">
      <div className="inc-period-breakdown__head">
        <span className="inc-period-breakdown__title">
          <i className="fa fa-youtube-play me-1" aria-hidden="true" />
          YouTube artists · {formatReportingPeriod(group?.period_start, group?.period_end)}
        </span>
        <span className="inc-period-breakdown__count">
          {rows.length} record{rows.length === 1 ? "" : "s"}
        </span>
      </div>

      <table className="inc-period-breakdown__table">
        <thead>
          <tr>
            <th>Artist</th>
            <th>Type</th>
            <th className="text-end">Revenue</th>
            <th>Status</th>
            <th className="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.id ?? row.entity_id ?? `${group?.id}-${index}`}>
              <td>
                {row.artist_name || row.title ? (
                  <button
                    type="button"
                    className="inc-period-breakdown__artist"
                    onClick={() => onEdit(row)}
                  >
                    {row.artist_name || row.title}
                  </button>
                ) : (
                  <span className="inc-muted-cell">—</span>
                )}
              </td>
              <td className="inc-muted-cell">
                {row.youtube_type === "artists_revenue" ? "Channel revenue" : "Income record"}
              </td>
              <td className="text-end">
                <span className="inc-amount inc-amount--youtube">
                  {row.amount == null ? "—" : formatIncomeAmount(row.amount)}
                  {row.currencies ? (
                    <span className="inc-amount__currency">{row.currencies}</span>
                  ) : null}
                </span>
              </td>
              <td>
                <IncomeStatusBadge status={row.status} />
              </td>
              <td className="text-end">
                <div className="inc-period-breakdown__actions">
                  <IncomeRowActions
                    row={row}
                    onCsvAction={onCsvAction}
                    onRetry={onRetry}
                    onViewReport={onViewReport}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onGenerateInvoice={onGenerateInvoice}
                    isProcessPending={isIncomeProcessing ? isIncomeProcessing(row.id) : false}
                    isDeletePending={isIncomeDeleting ? isIncomeDeleting(row.id) : false}
                    isRetryPending={isRetryPending}
                    isInvoicePending={isInvoicePending}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default YoutubePeriodBreakdown;
